<div class="menu mobile_menu menu-responsive">
  <div class="navigation">
    <a
      target="”_blank”"
      title="Close"
      class="close c-mobile-close-menu"
      data-toggle="close-main-menu"
      ><i class="fi-close-n-o"></i
    ></a>

    <ul class="primary-navigation p-0">
      <li class="first no-child">
        <a
          target="”_blank”"
          routerLink="/home"
          [queryParams]="{ dashboard: 'true' }"
          title="Home"
          class="first-level fi-home-n custom-tool-tip"
        ></a>
      </li>

      <li class="responsive-only">
        <a
          routerLink="/home"
          [queryParams]="{ dashboard: 'true' }"
          [innerText]="'MyRequests' | translate"
        >
        </a>
        <ul>
          <li class="no-child">
            <a
              routerLink="/services"
              target="”_blank”"
              class="second-level"
              [innerHTML]="'NewRequest' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              routerLink="/home"
              target="”_blank”"
              class="second-level"
              [innerHTML]="'trSearchRequests' | translate"
            ></a>
          </li>
        </ul>
      </li>

      <li class="responsive-only">
        <a href="#" [innerText]="'trImportantLinks' | translate"> </a>
        <ul>
          <li class="no-child">
            <a
              [href]="eServicesBaseLink + '/Account/FinancialTransactions.aspx'"
              target="”_blank”"
              class="second-level"
              [innerHTML]="'trFinancialTransactions' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              [href]="eServicesBaseLink + '/Workspaces/MyInbox.aspx'"
              target="”_blank”"
              class="second-level"
              [innerHTML]="'trMyInbox' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              [href]="eServicesBaseLink + '/WorkSpaces/SearchEservices.aspx'"
              target="”_blank”"
              class="second-level"
              [innerHTML]="'trSearchInServiceAndMailBox' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              [href]="eServicesBaseLink + '/WorkSpaces/SearchEservices.aspx'"
              target="”_blank”"
              class="second-level"
              [innerHTML]="'trSearchInServiceAndMailBox' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              href="https://refund.adib.ae/portal/MOCCAE/portal/login"
              target="”_blank”"
              class="second-level"
              [innerHTML]="'trRefundPortal' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              [href]="eServicesBaseLink + '/Account/ChangePassword.aspx'"
              target="”_blank”"
              class="second-level"
              [innerHTML]="'trChangePassword' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              [href]="
                eServicesBaseLink +
                '/Images/Manual/Mobile/user_manual_English.pdf'
              "
              target="”_blank”"
              class="second-level"
              [innerHTML]="'trDigitalServiceUserManual' | translate"
            ></a>
          </li>
        </ul>
      </li>

      <li class="no-child">
        <a
          target="”_blank”"
          [href]="mainWebsiteLink + lang + '/legislations'"
          class="first-level"
          [innerHTML]="'Legislations' | translate"
        ></a>
      </li>

      <li>
        <a
          target="”_blank”"
          [href]="mainWebsiteLink + lang + '/our-services'"
          class="first-level"
          [innerHTML]="'OurServices' | translate"
        ></a>
        <ul>
          <li class="first">
            <a
              target="”_blank”"
              [href]="
                mainWebsiteLink + lang + '/our-services/services-directory'
              "
              class="second-level"
              data-rel="../Content/Generated/Thumbnails/2cd5c618_961x3d1wffffff.jpg"
              [innerHTML]="'HomeHeaderServiceDirectory' | translate"
            ></a>
            <ul>
              <li class="first">
                <a
                  target="”_blank”"
                  [href]="
                    mainWebsiteLink +
                    lang +
                    '/our-services/services-directory#activity-professional-licensing'
                  "
                  [innerHTML]="
                    'HomeHeaderActivityProfessionalLicensing' | translate
                  "
                ></a>
              </li>
              <li>
                <a
                  target="”_blank”"
                  [href]="
                    mainWebsiteLink +
                    lang +
                    '/our-services/services-directory#export-import-services'
                  "
                  [innerHTML]="'HomeHeaderExportImportServices' | translate"
                ></a>
              </li>
              <li>
                <a
                  target="”_blank”"
                  [href]="
                    mainWebsiteLink +
                    lang +
                    '/our-services/services-directory#registration-accreditation'
                  "
                  [innerHTML]="
                    'HomeHeaderRegistrationAccreditation' | translate
                  "
                ></a>
              </li>
              <li>
                <a
                  target="”_blank”"
                  [href]="
                    mainWebsiteLink +
                    lang +
                    '/our-services/services-directory#fishermen-farmers-and-animal-breeders'
                  "
                  [innerHTML]="
                    'HomeHeaderFishermenFarmersAnimalBreedersServices'
                      | translate
                  "
                ></a>
              </li>
              <li class="last">
                <a
                  target="”_blank”"
                  [href]="
                    mainWebsiteLink +
                    lang +
                    '/our-services/services-directory#cites'
                  "
                  [innerHTML]="'HomeHeaderCites' | translate"
                ></a>
              </li>
            </ul>
          </li>

          <li class="no-child">
            <a
              target="”_blank”"
              [href]="mainWebsiteLink + lang + '/customer-service-centers'"
              class="second-level"
              [innerHTML]="'HomeHeaderServiceCenters' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="
                mainWebsiteLink + lang + '/media-center/mawroothna-initiative'
              "
              class="second-level"
              [innerHTML]="'HomeHeaderMawrothonaInitiative' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="
                mainWebsiteLink +
                lang +
                '/about-us/ministry-apps/seniar-application'
              "
              class="second-level"
              [innerHTML]="'HomeHeaderSeniarApplication' | translate"
            >
            </a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="
                mainWebsiteLink +
                lang +
                '/our-services/about-us/integrated-management-system-policy'
              "
              class="second-level"
              [innerHTML]="
                'HomeHeaderIntegratedManagementSystemPolicy' | translate
              "
            ></a>
          </li>

          <li class="no-child">
            <a
              target="”_blank”"
              [href]="
                mainWebsiteLink +
                '/assets/7378c2e7/approved-slaughterhouses.aspx'
              "
              class="second-level"
              [innerHTML]="'HomeHeaderApprovedSlaughterhouses' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="
                mainWebsiteLink +
                lang +
                '/our-services/list-of-approved-counties-for-importing-live-animals'
              "
              class="second-level"
              [innerHTML]="
                'HomeHeaderListofApprovedCountiesforImportingLiveAnimals'
                  | translate
              "
            >
            </a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="mainWebsiteLink + lang + '/about-us/ministry-apps'"
              class="second-level"
              [innerHTML]="'HomeHeaderMOCCAEMobileApps' | translate"
            ></a>
          </li>
          <li class="clearfix"></li>
        </ul>
      </li>

      <li>
        <a
          target="”_blank”"
          [href]="mainWebsiteLink + lang + '/knowledge'"
          class="first-level"
          [innerHTML]="'Knowledge' | translate"
        ></a>
        <ul>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="mainWebsiteLink + lang + '/knowledge/biodiversity'"
              class="second-level"
              [innerHTML]="'HomeHeaderBiodiversity' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="mainWebsiteLink + lang + '/knowledge/air-quality'"
              class="second-level"
              [innerHTML]="'HomeHeaderAirquality' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="mainWebsiteLink + lang + '/knowledge/food-safety'"
              class="second-level"
              [innerHTML]="'HomeHeaderFoodsafety' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="
                mainWebsiteLink +
                lang +
                '/knowledge/marine-environment-and-fisheries-sustainability'
              "
              class="second-level"
              [innerHTML]="
                'HomeHeaderMarineEnvironmentFisheriesSustainability' | translate
              "
            ></a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="
                mainWebsiteLink +
                lang +
                '/knowledge/animal-development-and-health'
              "
              class="second-level"
              [innerHTML]="'HomeHeaderAnimalDevelopmentHealth' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="
                mainWebsiteLink +
                lang +
                '/knowledge/agriculture-development-and-health'
              "
              class="second-level"
              [innerHTML]="'HomeHeaderAgricultureDevelopmentHealth' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="mainWebsiteLink + lang + '/knowledge/climate-change'"
              class="second-level"
              [innerHTML]="'HomeHeaderClimateChange' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="
                mainWebsiteLink +
                lang +
                '/knowledge/environment-and-green-development'
              "
              class="second-level"
              [innerHTML]="
                'HomeHeaderEnvironmentandGreenDevelopment' | translate
              "
            ></a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="
                mainWebsiteLink + lang + '/knowledge/wastes-and-chemicals'
              "
              class="second-level"
              [innerHTML]="'HomeHeaderWastesandchemicals' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="mainWebsiteLink + lang + '/knowledge/ecotourism'"
              class="second-level"
              [innerHTML]="'HomeHeaderEcotourism' | translate"
            ></a>
          </li>

          <li>
            <a
              target="”_blank”"
              [href]="mainWebsiteLink + lang + '/knowledge/biosecurity'"
              class="second-level"
              [innerHTML]="'HomeHeaderBiosecurity' | translate"
            ></a>
            <ul>
              <li class="first">
                <a
                  target="”_blank”"
                  [href]="
                    mainWebsiteLink +
                    lang +
                    '/knowledge/biosecurity/the-national-committee-of-the-biosecurity'
                  "
                  [innerHTML]="
                    'HomeHeaderTheNationalCommitteeoftheBiosecurity' | translate
                  "
                ></a>
              </li>
              <li>
                <a
                  target="”_blank”"
                  [href]="
                    mainWebsiteLink +
                    lang +
                    '/knowledge/biosecurity/uae-fourth-biosecurity-conference'
                  "
                  [innerHTML]="
                    'HomeHeaderUAEFourthBiosecurityConference' | translate
                  "
                ></a>
              </li>
              <li>
                <a
                  target="”_blank”"
                  [href]="
                    mainWebsiteLink +
                    lang +
                    '/knowledge/biosecurity/uae-third-biosecurity-conference'
                  "
                  [innerHTML]="
                    'HomeHeaderUAEThirdBiosecurityConference' | translate
                  "
                ></a>
              </li>
              <li class="last">
                <a
                  target="”_blank”"
                  [href]="
                    mainWebsiteLink +
                    lang +
                    '/knowledge/biosecurity/uae-second-biosecurity-conference'
                  "
                  [innerHTML]="
                    'HomeHeaderUAESecondBiosecurityConference' | translate
                  "
                ></a>
              </li>
            </ul>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="mainWebsiteLink + lang + '/knowledge/terminology'"
              class="second-level"
              [innerHTML]="'HomeHeaderTerminology' | translate"
            >
            </a>
          </li>
          <li class="clearfix"></li>
        </ul>
      </li>

      <li>
        <a
          target="”_blank”"
          [href]="mainWebsiteLink + lang + '/digital-participation'"
          class="first-level"
          [innerHTML]="'DigitalParticipation' | translate"
        ></a>
        <ul>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="
                mainWebsiteLink + lang + '/digital-participation/social-media'
              "
              class="second-level"
              data-rel="../Content/Generated/Thumbnails/34bd5296_961x3d1wffffff.jpg"
              [innerHTML]="'HomeHeaderSocialMedia' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="
                mainWebsiteLink +
                lang +
                '/digital-participation/digital-participation-guidelines'
              "
              class="second-level"
              [innerHTML]="
                'HomeHeaderDigitalParticipationGuidelines' | translate
              "
            ></a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="mainWebsiteLink + lang + '/digital-participation/poll'"
              class="second-level"
              [innerHTML]="'HomeHeaderPollResults' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="
                mainWebsiteLink +
                lang +
                '/digital-participation/communication-channels'
              "
              class="second-level"
              [innerHTML]="'HomeHeaderCommunicationChannels' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="mainWebsiteLink + lang + '/digital-participation/survey'"
              class="second-level"
              [innerHTML]="'HomeHeaderSurvey' | translate"
            >
            </a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="
                mainWebsiteLink +
                lang +
                '/digital-participation/contact-minister'
              "
              class="second-level"
              [innerHTML]="'HomeHeaderContactMinister' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="mainWebsiteLink + lang + '/digital-participation/blogs'"
              class="second-level"
              [innerHTML]="'HomeHeaderBlogs' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="
                mainWebsiteLink +
                lang +
                '/digital-participation/digital-consultations'
              "
              class="second-level"
              [innerHTML]="'HomeHeaderDigitalConsultations' | translate"
            ></a>
          </li>
          <li class="clearfix"></li>
        </ul>
      </li>

      <li>
        <a
          target="”_blank”"
          [href]="mainWebsiteLink + lang + '/media-center'"
          class="first-level"
          [innerHTML]="'MediaCenter' | translate"
        ></a>
        <ul>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="mainWebsiteLink + lang + '/media-center/news-and-media'"
              class="second-level"
              data-rel="../Content/Generated/Thumbnails/83b5b489_961x3d1wffffff.jpg"
              [innerHTML]="'HomeHeaderMOCCAENews' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="mainWebsiteLink + lang + '/media-center/news-and-media'"
              class="second-level"
              [innerHTML]="'HomeHeaderPhotoGallery' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="mainWebsiteLink + lang + '/media-center/news-and-media'"
              class="second-level"
              [innerHTML]="'HomeHeaderVisualLibrary' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="mainWebsiteLink + lang + '/media-center/publications'"
              class="second-level"
              [innerHTML]="'HomeHeaderPublications' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="mainWebsiteLink + lang + '/media-center/audio'"
              class="second-level"
              [innerHTML]="'HomeHeaderAudioGallery' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="
                mainWebsiteLink + lang + '/media-center/activities-and-events'
              "
              class="second-level"
              data-rel="../Content/Generated/Thumbnails/c4dcd83f_961x3d1wffffff.jpg"
              [innerHTML]="'HomeHeaderActivitiesandEvents' | translate"
            ></a>
          </li>
          <li class="last">
            <a
              target="”_blank”"
              [href]="mainWebsiteLink + lang + '/media-center/initiatives'"
              class="second-level"
              [innerHTML]="'HomeHeaderInitiatives' | translate"
            ></a>
            <ul>
              <li class="first">
                <a
                  target="”_blank”"
                  [href]="mainWebsiteLink + lang + '/media-center/initiatives'"
                  [innerHTML]="'HomeHeaderReadingInitiatives' | translate"
                ></a>
              </li>
              <li>
                <a
                  target="”_blank”"
                  [href]="mainWebsiteLink + lang + '/media-center/initiatives'"
                  [innerHTML]="
                    'HomeHeaderToleranceandSocialResponsibilityInitiatives'
                      | translate
                  "
                ></a>
              </li>
              <li class="last">
                <a
                  target="”_blank”"
                  [href]="mainWebsiteLink + lang + '/media-center/initiatives'"
                  [innerHTML]="'HomeHeaderInnovationInitiatives' | translate"
                ></a>
              </li>
            </ul>
          </li>
          <li class="clearfix"></li>
        </ul>
      </li>

      <li class="last">
        <a
          target="”_blank”"
          [href]="mainWebsiteLink + lang + '/open-data'"
          class="first-level"
          [innerHTML]="'OpenData' | translate"
        ></a>
        <ul>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="mainWebsiteLink + lang + '/open-data/moccae-open-data'"
              class="second-level"
              [innerHTML]="'HomeHeaderMOCCAEOpenData' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="
                'https://gis.moccae.gov.ae/arcgis/apps/sites/?fromEdit=true#/data'
              "
              class="second-level"
              data-rel="../Content/Generated/Thumbnails/4e3d4c83_961x3d1wffffff.jpg"
              [innerHTML]="'HomeHeaderGISMap' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="
                mainWebsiteLink + lang + '/open-data/propose-and-request-data'
              "
              class="second-level"
              [innerHTML]="'HomeHeaderRequestData' | translate"
            ></a>
          </li>
          <li class="no-child">
            <a
              target="”_blank”"
              [href]="
                mainWebsiteLink + lang + '/open-data/propose-and-request-data'
              "
              class="second-level"
              [innerHTML]="'HomeHeaderSubmitData' | translate"
            ></a>
          </li>
          <li class="clearfix"></li>
        </ul>
      </li>
    </ul>

    <div class="tools">
      <ul class="utilities">
        <li class="show-mobile">
          <a
            target="”_blank”"
            class="custom-tool-tip"
            routerLink="/home"
            [queryParams]="{ dashboard: 'true' }"
            title="Home"
            role="button"
            tabindex="0"
          >
            <i class="ico fi-home-n"></i>
          </a>
        </li>

        <li>
          <a
            class="personalize custom-tool-tip"
            title="Personalize"
            data-toggle="modal"
            data-target="#colorpopup"
            role="button"
            tabindex="0"
          >
            <i class="ico fi-settings-n"></i>
          </a>
        </li>

        <li class="show-mobile">
          <a
            target="”_blank”"
            *ngIf="isEnglish"
            (click)="changeLanguage('ar')"
            title="عربي"
            class="circle cursor-pointer custom-tool-tip"
            role="button"
            tabindex="0"
          >
            <i class="ico fi-arabic-n"></i>
          </a>
          <a
            target="”_blank”"
            *ngIf="isArabic"
            (click)="changeLanguage('en')"
            title="English"
            class="circle cursor-pointer custom-tool-tip"
            role="button"
            tabindex="0"
          >
            <i class="ico fi-english-n"></i>
          </a>
        </li>

        <li class="show-mobile">
          <a
            (click)="logout()"
            title="Logout from the account"
            class="circle custom-tool-tip"
            role="button"
            tabindex="0"
          >
            <span class="icon-logout"></span>
          </a>
        </li>

        <li class="show-mobile">
          <a
            target="”_blank”"
            [href]="editProfileURL + '?lang=' + lang"
            title="Register"
            class="circle custom-tool-tip"
            role="button"
            tabindex="0"
          >
            <span class="icon-edit-user"></span>
          </a>
        </li>

        <li class="hide-mobile">
          <a
            target="”_blank”"
            *ngIf="isEnglish"
            (click)="changeLanguage('ar')"
            title="عربي"
            class="circle cursor-pointer custom-tool-tip"
            role="button"
            tabindex="0"
          >
            <i class="ico fi-arabic-n"></i>
          </a>
          <a
            target="”_blank”"
            *ngIf="isArabic"
            (click)="changeLanguage('en')"
            title="English"
            class="circle cursor-pointer custom-tool-tip"
            role="button"
            tabindex="0"
          >
            <i class="ico fi-english-n"></i>
          </a>
        </li>
      </ul>

      <div style="display: none">
        <div class="aragement-vis" style="display: none">
          <ul>
            <li class="acc-hidden acc-border">
              <a
                target="”_blank”"
                class="toggle-display-icon toggle-display"
                title="Toggle display option"
              >
                <span class="icon icon-eye">Toggle display option</span>
              </a>
            </li>
            <li class="acc-hidden font-sizeinc-li">
              <a target="”_blank”" class="inc-font-size"
                ><span class="icon icon-util-increase-font-size"
                  >Increase Font Size</span
                ></a
              >
            </li>
            <li class="acc-hidden acc-font-border dec-font-size-li">
              <a target="”_blank”" class="dec-font-size"
                ><span class="icon icon-util-decrease-font-size"
                  >Decrease Font Size</span
                ></a
              >
            </li>
            <li class="acc-hidden acc-close-border">
              <a target="”_blank”" class="close-btn"
                ><span class="icon close-btn">X</span></a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
